import DarkBgCardsFrame from "@/components/darkBgCards";
import { ENHANCEMENTS_CONSTANTS } from "./constants";

const EnhancementsComp = () => {
  return (
    <DarkBgCardsFrame
      {...ENHANCEMENTS_CONSTANTS}
      columns={{ base: 1, sm: 2, md: 4 }}
      spacing={{ base: 4, md: 8 }}
    />
  );
};

export default EnhancementsComp;
